export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/18d928a827975ee4a7e6e7e15cda8a69.jpg)",
        }}
      />
      <div className="absolute inset-0 bg-[#2a3820]/70" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <p className="text-white/70 text-xs tracking-[0.4em] mb-8 font-light">
          KAMAKURA · NIKAIDO
        </p>
        <h1 className="text-white font-serif text-5xl md:text-6xl lg:text-7xl leading-tight mb-8 tracking-wide">
          身体を整え、<br />
          動ける状態へ。
        </h1>
        <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-12 font-light">
          鎌倉・二階堂、永福寺跡を見渡す自然に囲まれた隠れ家サロン。<br className="hidden md:block" />
          呼吸が深まり、身体の感覚が研ぎ澄まされていく静かな環境で、<br className="hidden md:block" />
          本来の身体機能を取り戻す時間を。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo("reserve")}
            className="px-8 py-4 bg-[#3a4a28] text-white text-sm tracking-[0.2em] hover:bg-[#4a5e35] transition-colors cursor-pointer whitespace-nowrap rounded-sm"
          >
            予約する
          </button>
          <button
            onClick={() => scrollTo("menu")}
            className="px-8 py-4 bg-transparent text-white border border-white/60 text-sm tracking-[0.2em] hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap rounded-sm"
          >
            LINEで相談
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-widest">SCROLL</span>
        <div className="w-px h-12 bg-white/30 animate-pulse" />
      </div>
    </section>
  );
}
